import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/vercel/path0/node_modules/@vercel/analytics/dist/react/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/jsvectormap/dist/jsvectormap.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/flatpickr/dist/flatpickr.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/nouislider/dist/nouislider.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/dropzone/dist/dropzone.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/myprofit/src/components/ui/css/simple-datatables.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/myprofit/src/components/ui/css/style.css");
